(function () {
  require('./lib/main').config(
    Object.assign(
      {},
      require('./lib/env-options'),
      require('./lib/cli-options')(process.argv)
    )
  )
})()



//////////////////
// WEBPACK FOOTER
// ./node_modules/dotenv/config.js
// module id = 1693
// module chunks = 0